export const initialState = {
	selectedEntity: undefined,
	selectedEntityChangesClone: undefined
};

export default initialState;
